<template>
  <div :class="`fe-w-full fe-h-xs fe-rounded-full ${backgroundColor}`">
    <div
      class="fe-h-xs fe-rounded-full"
      :class="filledColor"
      :style="{ width: progress + '%' }"
    ></div>
  </div>
</template>

<script>
  export default {
    name: "ProgressBar",
    props: {
      progress: {
        type: Number,
        required: true,
      },
      backgroundColor: {
        type: String,
        default: "fe-bg-primary-grey-40",
      },
      filledColor: {
        type: String,
        default: "fe-bg-success-50", // Default to Tailwind blue
      },
    },
  }
</script>
